import React, { useEffect, useState } from "react";
import { Button, Checkbox, Form } from "antd";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import LoginBG from "../../../../assets/images/login-pattern.png";
import { LoginRequest } from "../rules";
import { doLogin, setSessionTimeOut } from "../../../../store/AuthSlice";
import { Link, useNavigate } from "react-router-dom";
import { Notification, stringDecryption } from "../../../../config/Global";
import { assignErrorToInput } from "../../../../store/api";
import { useAppDispatch, useAppSelector } from "../../../../utils/hooks/hooks";

/**
 * Renders the LoginForm component.
 *
 * @return {ReactElement} The rendered LoginForm component.
 */
const LoginForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const [rememberMe, setRememberMe] = useState(false);
  const isLoading = useAppSelector((state) => state.auth.isLoading);
  const [form] = Form.useForm();
  const navigate = useNavigate();

    /**
   * Submits the form data to the server and handles the response ,
   * shows a notification and navigates to the home page on success,
   * throws an error on failure.
   *
   * @param {any} data - The form data to be submitted.
   * @return {Promise<void>} A promise that resolves when the form submission is complete.
   */
  const handleSubmit = (data: any) => {
    data.remember = rememberMe;
    dispatch(doLogin(data))
      .then(() => {
        Notification.info({
          message: "Your session will expire in 1 hour 30 min.",
        });
        dispatch(setSessionTimeOut(true));
        navigate("/");
      
      })
      .catch((error: any) => {
        assignErrorToInput(form, error?.STATUS);
      });
  };

  useEffect(() => {
    let rememberMe: any = localStorage.getItem("remember_me");
    if (rememberMe) {
      rememberMe = JSON.parse(stringDecryption(rememberMe));
      form.setFieldsValue({
        username: rememberMe.email,
        password: rememberMe.password,
        remember: true,
      });
      setRememberMe(true);
    }
  }, [form]);

  return (
    <div className="loginForm" style={{ backgroundImage: `url(${LoginBG})` }}>
      <div className="loginFormWrap">
        <div className="formTitle">
          <h2>Welcome IWNL Energy</h2>
        </div>
        <FormBox form={form} onFinish={handleSubmit}>
          <InputBox.Text
            name="username"
            label={"Email ID"}
            placeholder="example@domain.com"
            rules={LoginRequest.email("Email ID")}
          />
          <InputBox.Password
            name="password"
            label="Password"
            placeholder="xxxxxxx"
            rules={LoginRequest.password("Password")}
          />
          <div className="text-center">
            <Button loading={isLoading} type="primary" htmlType="submit">
              Login
            </Button>
          </div>
          <div
            className="mt-10 font-medium login_extra_fields"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Checkbox
              name="remember_me"
              checked={rememberMe}
              onChange={() => setRememberMe(!rememberMe)}
            >
              Remember me
            </Checkbox>
            <Link to="/forgot-password">Forgot Password?</Link>
          </div>
        </FormBox>
      </div>
    </div>
  );
};

export default LoginForm;
